<template>
  <div id="snapshots">
    <p>Traveler Snapshots</p>
    <div class="ig">
      <ImagesBoard :columns="2" :tag="tag" :loadMore="true"/>
    </div>
  </div>
</template>

<script>
import ImagesBoard from "@/components/ImagesBoard";

export default {
  name: "Snapshots",
  components: {
    ImagesBoard
  },
  props: {
    tag: {
      type: Number
    }
  }
};
</script>

<style lang="scss" scoped>
#snapshots {
  padding: 0 22px 30px;

  .ig {
    margin: 0 -22px 25px;
    min-height: 543px;
  }

  .btn-snapshots {
    border: 2px #e13036 solid;
    color: #e13036;
    font-size: 16px;
    font-weight: bold;
  }
}
</style>


